import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/articles';
import { getCategoryName } from '@/utils/content';
import StatusBadge from '@/components/base/StatusBadge';

const highlights = [
  { icon: 'ri-file-list-3-line', text: '每条案例附完整时间线' },
  { icon: 'ri-link-m', text: '标注信息来源与核实状态' },
  { icon: 'ri-user-unfollow-line', text: '涉事人物统一匿名处理' },
];

export default function Hero() {
  const featured = hotArticles[0];

  return (
    <section className="relative overflow-hidden border-b border-background-300 bg-background-50">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 top-1/2 hidden h-[420px] w-[420px] -translate-y-1/2 rounded-full border border-primary-100 lg:block"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-8 top-1/2 hidden h-[260px] w-[260px] -translate-y-1/2 rounded-full border border-accent-200 lg:block"
      />

      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:items-center lg:gap-12">
        <div className="lg:col-span-6">
          <h1 className="font-heading">
            <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-semibold font-label text-primary-700">
              <i className="ri-radar-line" aria-hidden="true" />
              真相回旋镖 · 爆料反转观察站
            </span>
            <span className="block text-3xl font-bold leading-tight text-foreground-950 sm:text-4xl md:text-5xl">
              看清黑料背后的
              <br className="hidden sm:block" />
              <span className="text-primary-600">真实走向</span>
            </span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600">
            爆料刚出现时总是言之凿凿，真正的答案往往藏在后面。我们把一条黑料从出现、发酵到
            <strong className="font-semibold text-foreground-900">辟谣澄清</strong>、真相后续的完整过程整理成可追溯的记录，帮你少被情绪带着走。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/archive"
              className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium font-label text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-file-list-3-line" aria-hidden="true" />
              浏览反转档案
            </Link>
            <Link
              to="/faq"
              className="flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium font-label text-foreground-800 whitespace-nowrap transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-question-line" aria-hidden="true" />
              了解核实方法
            </Link>
          </div>

          <ul className="mt-9 flex flex-wrap gap-x-6 gap-y-3">
            {highlights.map((item) => (
              <li key={item.text} className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-sm`} aria-hidden="true" />
                </span>
                {item.text}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6">
          {featured ? (
            <article className="overflow-hidden rounded-lg border border-background-300 bg-background-50">
              <Link
                to={`/article/${featured.id}`}
                className="group relative block aspect-[16/9] w-full overflow-hidden bg-background-200"
              >
                <img
                  src={featured.cover}
                  alt={`${featured.title} 配图`}
                  title={`${featured.title}｜爆料反转真相`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent" />
                <span className="absolute left-4 top-4 flex items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold font-label text-background-50">
                    本期主推
                  </span>
                  <StatusBadge status={featured.status} className="border-transparent bg-background-50/90 backdrop-blur" />
                </span>
                <span className="absolute bottom-4 left-4 right-4">
                  <span className="font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">
                    {featured.title}
                  </span>
                </span>
              </Link>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs font-label text-foreground-500">
                  <span className="font-medium text-secondary-700">{getCategoryName(featured.category)}</span>
                  <span className="h-3 w-px bg-background-400" />
                  <span>{featured.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                    热度 {featured.heat}
                  </span>
                </div>
                <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {featured.summary}
                </p>
                <div className="mt-4 flex items-center gap-2">
                  {featured.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-md bg-background-100 px-2.5 py-1 text-xs font-label text-foreground-600"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ) : null}
        </div>
      </div>
    </section>
  );
}